import { Input, InputRef } from "antd";
import { forwardRef, memo } from "react";
import { InputProps } from "antd/lib";
import SelectAjax from "../../ui/SelectAjax";

interface FormInputSelectorProps extends InputProps {
  featureId: number;
  categoryId: number;
  onChange?: (value: any) => void;
}

export const FormInputSelector = memo(
  forwardRef<InputRef, FormInputSelectorProps>(
    ({ featureId, onChange, categoryId, ...props }, ref) => {
      if (featureId === 1) {
        return (
          <SelectAjax
            {...(props as any)}
            style={{ width: 170 }}
            url="/vehicle-categories"
            valueProp={"name"}
            onChange={onChange}
          />
        );
      }

      if (featureId === 7) {
        return (
          <SelectAjax
            {...(props as any)}
            style={{ width: 170 }}
            url="/bodywork"
            valueProp={"name"}
            onChange={onChange}
          />
        );
      }

      if (featureId === 8) {
        return (
          <SelectAjax
            {...(props as any)}
            style={{ width: 170 }}
            url="/fuel"
            valueProp={"name"}
            onChange={onChange}
          />
        );
      }

      return (
        <Input
          onChange={(e) => onChange(e.target.value)}
          ref={ref}
          {...props}
        />
      );
    }
  )
);
